<template>
    <div>
        <form @keydown="submitted = false"
              @submit.prevent="create"
              class="form-horizontal form-bordered form-row-stripped">

            <div v-bind:class="[errors.name ? 'has-error' : '', 'form-group']">
                <label for="user-name"
                       class="control-label col-md-3"
                       v-text="Lang.get('messages.createAssignUser.label.name')">

                </label>
                <div class="col-md-9">
                    <input name="user-name"
                           id="user-name"
                           type="text"
                           :placeholder="Lang.get('messages.createAssignUser.label.name')"
                           class="form-control"
                           v-model="form.name"
                           @keydown="delete errors.name">
                    <span class="help-block" v-text="errors.name[0]" v-if="errors.name"></span>
                </div>
            </div>

            <div v-bind:class="[errors.email ? 'has-error' : '', 'form-group']">
                <label for="user-email" class="control-label col-md-3">
                    E-mail
                </label>
                <div class="col-md-9">
                    <input name="user-email"
                           id="user-email"
                           type="email"
                           placeholder="E-mail"
                           class="form-control"
                           v-model="form.email"
                           @keydown="delete errors.email">
                    <span class="help-block" v-text="errors.email[0]" v-if="errors.email"></span>
                    <span class="help-block" v-if="! errors.email" v-text="Lang.get('messages.createAssignUser.help.email')"></span>
                </div>
            </div>

            <div class="form-actions">
                <div class="row">
                    <div class="col-md-offset-3 col-md-9">
                        <button type="submit"
                                class="btn btn-primary"
                                :disabled="submitted"
                                v-text="Lang.get('messages.createAssignUser.submit')">
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['institution'],
        data() {
            return {
                form: {
                    name: this.name,
                    email: this.email,
                    password: Math.random().toString(36).substr(2, 5),
                },
                id: this.institution.id,
                submitted: false,
                errors: {},
            }
        },

        methods: {
            create() {
                this.submitted = true;

                axios.post('/admin/institutions/' + this.id + '/users/create-and-assign', this.form)
                    .then(() => {
                        flash(Lang.get('messages.createAssignUser.success', { email: this.form.email}));
                        this.$emit('created');
                        this.resetForm();
                    }).catch(errors => {
                        this.errors = errors.response.data.errors;
                    });
            },

            resetForm() {
                this.form.name = this.form.email = '';
                this.form.password = Math.random().toString(36).substr(2, 5);
            }
        }
    }
</script>
